import React, { Component, Fragment } from 'react';
import { Container, Button, Navbar, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from './OST_Logo_Text.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

    renderHosting() {
            return (
                <Fragment>
                    <NavItem >
                        <Button tag={Link} to="/hosting" color="secondary">Hosting</Button>
                    </NavItem>
                    <NavItem>
                        <div style={{ width: 20 }} />
                    </NavItem>
                </Fragment>
            );
    }

    render() {

    return (
        <header>
            <Navbar className="fixed-top navbar-expand-sm ng-white bg-white border-bottom box-shadow mb-3" light>
                <Container>
                    <NavbarBrand tag={Link} to="/" >Kanban Game</NavbarBrand>
                    <Nav>
                        {this.props.showHosting && this.renderHosting()}
                        <NavItem className="no-margin">
                            <NavLink className="no-padding" href="https://www.ost.ch/de/studium/technik/bachelor-wirtschaftsingenieurwesen" target="_blank" rel="noopener noreferrer">
                                <img className="align-content-center nav-image" src={logo} alt="OST"  />
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Container>
            </Navbar>
        </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.jsx